import React from 'react';

import { ReactComponent as Icon } from '../../../assets/coin.svg';

export const CoinIcon = ({size, color}) => {
    return (
        <Icon alt="coin icon" className="coin_icon" style={{ width: size + 'px', fill: color }} />
    );
};